module.exports = __webpack_public_path__ + "img/7.022fa289.jpg";